import { render, staticRenderFns } from "./LateralMenu.vue?vue&type=template&id=a993ff20&lang=pug&"
import script from "./LateralMenu.vue?vue&type=script&lang=js&"
export * from "./LateralMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports